export default "__VITE_PUBLIC_ASSET__dbaba7d4__"